import {CompositionNl} from "../../models/composition-nl";
import {ComponentNl} from "../../models/component-nl";
import {InterchangeableComponentGroupNl} from "../../_modules/inventory/_models/interchangeable-component-group-nl";

export class CompositionComponentLinkerDto {
  id: string = "";
  /**
   * Zero-based position of this slot ("Bestandteil") within its article — the arrangement made on this
   * screen, echoed back by the server (Bug #728). The API already returns `componentLinkers` sorted by it,
   * so nothing in the SPA has to re-sort; it is carried here so the field round-trips and so a consumer that
   * receives the list out of band still has the arrangement.
   */
  order: number = 0;
  composition!: CompositionNl;
  component: ComponentNl | undefined;
  interchangeableComponentGroup: InterchangeableComponentGroupNl | undefined = undefined;
}
